import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-gewone-giften',
  templateUrl: './tekst-aftrekbare-gewone-giften.component.html',
  styleUrls: ['./tekst-aftrekbare-gewone-giften.component.scss'],
})
export class TekstAftrekbareGewoneGiftenComponent {}
